function Text(props) {
    return (
        <span>
            {props.value}
        </span>
    );
}

export default Text;